import React, { useState, useEffect } from "react";
import MainSideBar from "../../Components/Sidebar/sidebar";
import { DataGrid } from "@mui/x-data-grid";
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import './dashboard.css'


const Dashboard = (props)=>{
    const [artists, setArtists] = useState([])
    const [empty, setEmpty] = useState(false);
    const [loadStatus, setLoadStatus] = useState(true)
    const [pageSize, setPageSize]  = useState(8)
    let navigate = useNavigate();

    useEffect(()=>{
        props.setCurrentMenu("dashboard")
        props.setIsLoggedIn(true)
        fetch("https://creath.tech/api/artists" )
        .then(response => response.json())
        .then((data)=>{
            if(data.data.length > 0){
                setArtists(data.data)
                setLoadStatus(false)
            }
            else{
                setEmpty(true)
                setLoadStatus(false)
            }
        })
        .catch((e)=>{
            console.log(e)
        })
    },[])

    const changePage = (n)=>{
        navigate(n)
    }

    const column = [
        {
            field: 'id', headerName: 'ID', type: 'number'
        },
        {
            field: 'full_name', headerName: 'Name',width: 200
        },
        {
            field: 'email', headerName: 'Email',width: 200
        },
        {
            field: 'country', headerName: 'Country',width: 200
        },
        {
            field: 'state', headerName: 'State',width: 200
        },
        {
            field: 'created_at', headerName: 'Date', type: 'date',width: 300
        }
    ]

    const handleRowClick = (params)=>{
        props.setCurrentArtist(params.row)
        changePage('/artistProfile')
        localStorage.setItem('currentArtist', JSON.stringify(params.row))
    }


    return(
        <div className="mainDash">
            <MainSideBar setCurrentMenu = {props.setCurrentMenu} currentMenu = {props.currentMenu}/>
            <div className="dashSubMain">
                <div className="dashHeader">
                    <p>Dashboard</p>
                    <div>
                        <input></input>
                    </div>
                </div>
                <div className="dashCards">
                    <div className="card">
                        <p className="item"> Artists</p>
                        <p className="value">{artists.length}</p>
                    </div>
                    <div className="card">
                        <p className="item">Artworks</p>
                        <p className="value">{props.Arts.length}</p>
                    </div>
                </div>
                <p className="dashArtistListingText">Artist Listings</p>
                <div className="artistGrid">
                    <Box sx={{ height: 400, width: '100%' }}>
                        <DataGrid
                            columns={column}
                            rows={artists}
                            loading={loadStatus}
                            pageSize = {pageSize}
                            onPageSizeChange = {(newPageSize)=>setPageSize(newPageSize)}
                            rowsPerPageOptions = {[8, 16, 24]}
                            autoHeight
                            pagination
                            onRowClick={handleRowClick}
                        />
                    </Box>
                </div>
            </div>
        </div>
    )
}

export default Dashboard